module.exports = __webpack_public_path__ + "static/media/visa.ed9ecd6c.svg";